export class UserRoute {
  id?: string;
  name: string;

  constructor(name) {
    this.name = name;
  }

}
